import * as React from 'react';

function SvgComponent(props) {
    return (
        <svg
            viewBox="0 0 19 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M10.506 2.198c1.76.004 3.244.078 5.75.259.858.062 1.588.688 1.681 1.543.091.844.082 1.6-.018 2.491-.096.853-.8 1.5-1.654 1.587-2.35.24-3.531.312-5.759.207M3.77 2.386c-.215.02-.44.043-.675.067-.854.088-1.558.734-1.654 1.587-.1.891-.11 1.647-.018 2.49.092.856.822 1.483 1.68 1.545l.666.047"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5.457 3.124c.628-.627.725-1.203 1.181-1.783a.879.879 0 011.39 0c.456.58.553 1.156 1.18 1.783.628.628 1.204.725 1.784 1.181a.879.879 0 010 1.39c-.58.456-1.156.553-1.783 1.18-.628.628-.725 1.204-1.181 1.784a.879.879 0 01-1.39 0c-.456-.58-.553-1.156-1.18-1.783-.628-.628-1.204-.725-1.784-1.181a.879.879 0 010-1.39c.58-.456 1.156-.553 1.783-1.18z"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default SvgComponent;
